import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SubjectService from "../../services/subject.service";


export const addSubject = createAsyncThunk(
  "classsubject/addSubject",
  async (data, thunkAPI) => {
    try {
      const response = await SubjectService.addSubject(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const updateSubject = createAsyncThunk(
  "classsubject/updateSubject",
  async (payload, thunkAPI) => {
    try {
      const response = await SubjectService.updateSubject(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getSubject = createAsyncThunk(
  "subject/getsubject",
  async (payload, thunkAPI) => {
    try {
      const response = await SubjectService.getSubject(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getClassSubject = createAsyncThunk(
  "subject/getClassSubject",
  async (item, thunkAPI) => {
    try {
      const response = await SubjectService.getClassSubject(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const getExamSubject = createAsyncThunk(
  "subject/getExamSubject",
  async (item, thunkAPI) => {
    try {
      const response = await SubjectService.getExamSubject(item);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const addClassSubject = createAsyncThunk(
  "classsubject/addclasssubject",
  async (data, thunkAPI) => {
    try {
      const response = await SubjectService.addClasssubject(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);



export const addExamSubject = createAsyncThunk(
  "examsubject/addexamsubject",
  async (data, thunkAPI) => {
    try {
      const response = await SubjectService.addExamSubject(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);


export const updateClassSubject = createAsyncThunk(
  "classsubject/updateStudent",
  async (payload, thunkAPI) => {
    try {
      const response = await SubjectService.updateClassSubject(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateExamSubject = createAsyncThunk(
  "examsubject/updateExamSubject",
  async (payload, thunkAPI) => {
    try {
      const response = await SubjectService.updateExamSubject(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  subjectlist: [],
  classsubjectlist: [],
  examsubjectlist: [],

  updateSuccess: false,
};


const subjectSlice = createSlice({
  name: "subject",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(getSubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getSubject.fulfilled, (state, action) => {
        state.loading = false;
        state.subjectlist = action.payload?.data || [];
      })

      .addCase(getSubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getClassSubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getClassSubject.fulfilled, (state, action) => {
        state.loading = false;

        // 🔥 IMPORTANT: API returns { status, message, data: [] }
        state.classsubjectlist = action.payload?.data || [];
      })

      .addCase(getClassSubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getExamSubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getExamSubject.fulfilled, (state, action) => {
        state.loading = false;

        // 🔥 IMPORTANT: API returns { status, message, data: [] }
        state.examsubjectlist = action.payload?.data || [];
      })

      .addCase(getExamSubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});


export const { resetUpdateStatus } = subjectSlice.actions;
export default subjectSlice.reducer;
